<template>
	<div :class="type" class="editor-popover">
		<slot/>
	</div>
</template>

<script>
	export default {
		props: {
			type: {
				type: String,
				required: true
			}
		}
	}
</script>

<style lang="less">
	.editor-popover {
		position: absolute;
		top: 100%;
		left: 0;
		// margin: 0 15px;
		// position: static !important;

		padding: 20px;
		background-color: #3d464a;
		z-index: 99;
		color: #fff;
		font-size: 14px;

		* {
			// pointer-events: none;
			tab-size: 0;
		}

		.sentence-previewer {
			max-width: 400px;
			height: 100%;
		}
	}
</style>

